import request from '@/utils/request'

// 获取作业配置数据（匿名）
export const homeworkGetHomeBaseData = params => {
    return request({
        url: '/homework/getHomeBaseData',
        method: 'post',
        data: params
    })
};
// 获取教材目录数据（匿名）
export const homeworkGetHomeDirectoryData = params => {
    return request({
        url: '/homework/getHomeDirectoryData',
        method: 'post',
        data: params
    })
};

// 添加资源数据
export const homeworkAddHomeworkData = params => {
    return request({
        url: '/homework/addHomeworkData',
        method: 'post',
        data: params
    })
};

// 查看资源数据审核
export const homeworkQueryHomeworkApprove = params => {
    return request({
        url: '/homework/queryHomeworkApprove',
        method: 'post',
        data: params
    })
};
// 资源数据审核
export const homeworkUpdateHomeworkApprove = params => {
    return request({
        url: '/homework/updateHomeworkApprove',
        method: 'post',
        data: params
    })
};
// 删除资源数据
export const homeworkDeleteHomework = params => {
    return request({
        url: '/homework/deleteHomework',
        method: 'post',
        data: params
    })
};
// 编辑资源数据
export const homeworkEditHomework = params => {
    return request({
        url: '/homework/editHomework',
        method: 'post',
        data: params
    })
};
